import i18nextBase, {type i18n} from 'i18next'
import {type TranslationFunction} from '..'

type TypedI18Next = {
  [K in keyof i18n]: K extends 't' ? TranslationFunction : i18n[K]
}

export const i18next = i18nextBase as TypedI18Next
export type {TypedI18Next, i18n}
